/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharestatuspending2Inputs */

const en_sharestatuspending2 = /** @type {(inputs: Sharestatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const de_sharestatuspending2 = /** @type {(inputs: Sharestatuspending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vorgemerkt`)
};

/**
* | output |
* | --- |
* | "pending" |
*
* @param {Sharestatuspending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharestatuspending2 = /** @type {((inputs?: Sharestatuspending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharestatuspending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharestatuspending2(inputs)
	return de_sharestatuspending2(inputs)
});
export { sharestatuspending2 as "shareStatusPending" }